import React, { useEffect } from "react";
import styles from "./CartSuccess.module.css";
import PropTypes from "prop-types";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { Button, Typography } from "@material-ui/core";
import history from "core/helper/Helper";
import { RouterName } from "shared/RouterName";
import {
  fetchClearCartInLocalStorage,
  fetchPaidOfCartOnline,
} from "redux/ActionCreators/CartActionCreators";
import { useDispatch } from "react-redux";

function CartSuccess(props) {
  const { idCart } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchClearCartInLocalStorage());
  });

  const handleContinueShopping = () => {
    history.push(RouterName.HomePage.url);
  };

  return (
    <div className={styles.container}>
      <div>
        <Typography variant="h2" component="h2" gutterBottom>
          Thành Công
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          Sản phẩm sẽ được chuyển đến bạn trong thời gian sớm nhất!
        </Typography>
      </div>
      <div className={styles.icon}>
        <CheckCircleIcon style={{ fontSize: "180px" }} />
      </div>
      <div>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleContinueShopping}
        >
          Tiếp tục mua sắm
        </Button>
      </div>
    </div>
  );
}

CartSuccess.propTypes = {
  idCart: PropTypes.string,
};

export default CartSuccess;
